// extracted by mini-css-extract-plugin
module.exports = {"blurb-wrapper":"gfbWS","blurb-text":"_3pqR1"};